import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AlertMessage } from '../components/AlertMessage';
import { CustomDataTable } from '../components/CustomDataTable';
import { LoadingBox } from '../components/LoadingBox';
import { ToolBar } from '../components/ToolBar'
import Swal from 'sweetalert2';
import { getNotificationsUser } from '../actions/notificationActions';
import { createMessageExtracurricularActivities } from '../actions/messageActions';
import removeAccents from '../utils/removeAccents';
import Select from "react-select"
import { generatePath, useNavigate } from 'react-router-dom';
import { getAvailableSubscriptions } from '../actions/subscriptionProductActions';
import { getAvailableProducts } from '../actions/productActions';
import { getAvailableExtracurricularActivities, getAvailableSplittedExtracurricularActivities } from '../actions/extracurricularActivityActions';
import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, ContentState, convertToRaw } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import { changeMenu } from '../actions/navigationActions';

export const ExtracurricularActivityMessageScreen = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const {loading, error, extracurricularActivitiesSplitted} = useSelector((state) => state.extracurricularActivitySplittedList);

    const {loading: loadingProducts, error: errorProducts, products} = useSelector((state) => state.productList);
    const {loading: loadingSubscriptionProducts, error: errorSubscriptionProducts, subscriptionProducts} = useSelector((state) => state.subscriptionProductList);
    const {loading: loadingExtracurricularActivities, error: errorExtracurricularActivities, extracurricularActivities} = useSelector((state) => state.extracurricularActivityList);

    const { userInfo } = useSelector(state => state.userSignin);
    const [message, setMessage] = useState('')
    const [editorState, setEditorState] = useState(EditorState.createEmpty())
    const modalCancelButton = useRef(null)
    const [subject, setSubject] = useState('')
    const [sendingMessage, setsendingMessage] = useState(false)
    const [selectedExtracurricularActivities, setSelectedExtracurricularActivities] = useState([])
    const [singleExtracurricularActivitySelected, setSingleExtracurricularActivitySelected] = useState(null)

    const [update, forceUpdate] = useState(0)

    const [productOptions, setProductOptions] = useState([])
    const [productSelected, setProductSelected] = useState(null)

    const pushMessageHandler = async(e) => {
        e.preventDefault();
        let extracurricularActivitiesCopy = [...selectedExtracurricularActivities]

        if (singleExtracurricularActivitySelected) {
            extracurricularActivitiesCopy.push(singleExtracurricularActivitySelected)
        }
        if (extracurricularActivitiesCopy.length > 0) {
            setsendingMessage(true)
            dispatch(createMessageExtracurricularActivities({
                sender: userInfo._id,
                subject: subject,
                extracurricularActivities: extracurricularActivitiesCopy,
                message: message
            }))
            setsendingMessage(false)
            Swal.fire({
                position: 'center',
                iconHtml: '<img src="/success.svg" class="mt-5">',
                html: '<p class="mb-7 mt-10 fw-bolder fs-2">Mensajes enviados</p><p class="mb-5">Hemos enviado los mensajes a sus destinatarios de forma correcta.</p><p class="fw-bolder">¿Qué quieres hacer ahora?</p>',
                showConfirmButton: true,
                showDenyButton: true,
                denyButtonText: `<button type="button" class="btn btn-info-outline text-info rounded-pill mt-0"><img src="/store.svg" alt="Tienda" class="me-2">Ir a tienda</button>`,
                denyButtonColor: "white",
                confirmButtonText: `<button type="button" class="btn btn-light-red-outline text-light-red rounded-pill mt-0"><img src="/school.svg" alt="Tienda" class="me-2">Ir a colegio</button>`,
                confirmButtonColor: "white",
                customClass: "invisible-buttons"
            }).then(result => {
                if (result.isConfirmed) {
                    dispatch(changeMenu("school"))
                    navigate('/')
                }
                if (result.isDenied) {
                    dispatch(changeMenu("store"))
                    navigate('/')
                }
            })
        }

        closeModal()
    }

    const selectExtracurricularActivities = ({selectedRows, selectedCount, allSelected}) => {
        setSelectedExtracurricularActivities(selectedRows.map(course => course._id))
        if (allSelected) {
            Swal.fire({
                toast: true,
                position: 'top',
                icon: 'success',
                title: `${selectedCount} actividades extraescolares seleccionadas`,
                showConfirmButton: false,
                timer: 2000
            })
        }
    }

    const closeModal = () => {
        setSingleExtracurricularActivitySelected(null);
        setMessage('')
        setSubject('')
        setEditorState(EditorState.createEmpty())
        modalCancelButton.current.click()
    }

    const handleEditorStateChange = (editorState) => {
        setEditorState(editorState)

        setMessage(draftToHtml(convertToRaw(editorState.getCurrentContent())))
    }

    const columns = [
        {
            name: 'Actividad extraescolar',
            cell: row =>
                <div className="d-flex align-items-center">                    
                    <div className="ms-5">
                        <span className="text-gray-800 text-hover-primary fs-5 fw-bolder">{row.name}</span>
                    </div>
                </div>,
            selector: (row) => removeAccents(row.name),
            sortable: true,
        },
        {
            name: "Acciones",
            cell: row => 
            <div className="row">
                <div className="col-12 d-flex align-items-center">
                    {userInfo.isTeacher ?
                        <>
                            <i className='far fa-envelope px-2' style={{fontSize: '1.4rem', cursor: 'pointer'}}  data-bs-toggle="modal" data-bs-target="#staticBackdrop" onClick={() => setSingleExtracurricularActivitySelected(row._id)} title="Mensaje"/>
                        </>
                    :
                        <></>
                    }
                </div>
            </div>,
            right: true,
        }
    ];

    const conditionalRowStyles = [ 
        {
            when: row => selectedExtracurricularActivities.some(c => c === row._id),
            style: {
                backgroundColor: "#F3FBFF"
            }
        }
    ]

    const addProduct = () => {
        if (productSelected) {
            const productLink = generatePath(`/${productSelected.type}/:id`, {
                id: productSelected._id
            })
            let messageParts = message.split('</p>')

            if (messageParts.length === 1 && messageParts[0] === '') {
                messageParts[0] = '<p>' + messageParts[0]
            }
            
            if (messageParts[messageParts.length - 1] === '' && messageParts.length !== 1) {
                messageParts.splice(messageParts.length - 1, 1)
            }

            messageParts[messageParts.length - 1] += ` <a href="${productLink}">${productSelected.name}</a>&nbsp;`
            setMessage(messageParts.join('</p>'))
            
            const blocksFromHtml = htmlToDraft(messageParts.join('</p>'))
            const { contentBlocks, entityMap } = blocksFromHtml
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks, entityMap)))

            setProductSelected(null)
            forceUpdate(update + 1)
        }
    }

    useEffect(() => {
        dispatch(getAvailableSplittedExtracurricularActivities())
        dispatch(getNotificationsUser());
        dispatch(getAvailableExtracurricularActivities())
        dispatch(getAvailableSubscriptions())
        dispatch(getAvailableProducts())
        setProductOptions([])
    }, [dispatch])

    useEffect(() => {
        let productToUse = []
        
        productToUse = productToUse.concat(products?.map(product => (
            {...product, label: product.name, value: product._id, type: 'product'}
        )))

        productToUse = productToUse.concat(subscriptionProducts?.map(subscriptionProduct => (
            {...subscriptionProduct, label: subscriptionProduct.name, value: subscriptionProduct._id, type: 'subscriptionProduct'}
        )))

        productToUse = productToUse.concat(extracurricularActivities?.map(extracurricularActivity => (
            {...extracurricularActivity, label: extracurricularActivity.name, value: extracurricularActivity._id, type: 'extracurricularActivity'}
        )))

        productToUse.sort((a, b) => {
            return a.name.localeCompare(b.name)
        })

        setProductOptions(productToUse)
    }, [products, subscriptionProducts, extracurricularActivities])

    return (
        <>
            <ToolBar titulo={"Mensajería"} hitos={[
                { titulo: "Inicio", enlace: "/" },
                { titulo: "Cursos", enlace: "#" },
            ]} />
            <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
                <div className="content flex-row-fluid" id="kt_content">
                    {error ? <AlertMessage variant={"danger"} message={error} /> : <></>}
                    {errorProducts ? <AlertMessage variant={"danger"} message={errorProducts} /> : <></>}
                    {errorExtracurricularActivities ? <AlertMessage variant={"danger"} message={errorExtracurricularActivities} /> : <></>}
                    {errorSubscriptionProducts ? <AlertMessage variant={"danger"} message={errorSubscriptionProducts} /> : <></>}
                    {loading || loadingProducts || loadingExtracurricularActivities || loadingSubscriptionProducts ? (<LoadingBox variant={"primary"} />) :
                        (
                            <div className="card card-flush">
                                <div className="card-body pt-0">
                                    <CustomDataTable pagination data={extracurricularActivitiesSplitted} columns={columns} selectableRows onSelectedRowsChange={selectExtracurricularActivities} conditionalRowStyles={conditionalRowStyles} />
                                    <div className='d-flex justify-content-end mt-10'>
                                        <div className='w-75 row'>
                                            <div className='col-6 d-grid offset-6'>
                                                <button type="button" className="btn btn-lg btn-primary rounded-pill py-5" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                                                    {sendingMessage ? (<LoadingBox variant={"primary"}/>)
                                                    :
                                                    (<span className="indicator-label">Escribir mensaje</span>)}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                </div>
            </div>
            <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content p-3">
                        <div className="modal-header border-0">
                            <div className="text-start w-100">
                                <div className='d-flex align-items-center mb-1'>
                                    <h2 className="text-primary fs-1 mb-0">Mensaje</h2>
                                </div>
                                <div className='separator'/>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className='row mb-8'>
                                <div className='col-12'>
                                    <label className="form-label fs-6 fw-bolder text-dark">Asunto</label>
                                    <input className="form-control form-control-lg form-control-solid" id="subject" type="text" placeholder="Título del mensaje" value={subject || ''} onChange={ e =>setSubject(e.target.value)}/>
                                </div>
                            </div>
                            <div className='row my-8 align-items-end'>
                                <div className='col-12 col-md-9 mb-4 mb-md-0'>
                                    <label className="form-label fs-6 fw-bolder text-dark">Añadir enlace a producto</label>
                                    <Select key={update} styles={{menuPortal: base => ({...base, position: 'relative'})}} className='react-select-control' placeholder="Selecciona el producto" options={productOptions} selected={productSelected} onChange={selectedValue => setProductSelected(selectedValue)} />
                                </div>
                                <div className='col-12 col-md-3'>
                                    <button type='button' className='btn btn-primary rounded-pill w-100' onClick={addProduct}>Añadir enlace</button>
                                </div>
                            </div>
                            <Editor
                                toolbar={{
                                    options: ['inline', 'list', 'textAlign', 'link'],
                                    inline: { options: ['bold', 'italic', 'underline'] },
                                    list: { options: ['unordered', 'ordered'] },
                                    textAlign: { options: ['left', 'center', 'right'] },
                                    link: { options: ['link', 'unlink'] }
                                }}
                                editorState={editorState}
                                onEditorStateChange={handleEditorStateChange}
                            />
                            <div className='d-flex justify-content-end mt-10 mb-5'>
                                <div className='w-75 row'>
                                    <div className='col-6 d-grid'>
                                        <button type="button" className="btn btn-lg btn-outline-dark border border-dark rounded-pill py-5" data-bs-dismiss="modal" ref={modalCancelButton} onClick={closeModal}>Cancelar</button>
                                    </div>
                                    <div className='col-6 d-grid'>
                                        <button type="button" className="btn btn-lg btn-primary rounded-pill py-5" onClick={pushMessageHandler}>Enviar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
